import { useEffect } from "react";
import ApplicationContainer from "components/application-container/ApplicationContainer";
import UncompletedApplicationExpiredCard from "components/card/uncompleted-application-expired/UncompletedApplicationExpired";
import { GA_DEDUP_KEYS, GA_EVENT_CONFIGS } from "constants/gaEvents";
import { pushGTMEventOnce } from "utils/gaEventDedup";

const UncompletedApplicationExpiredPage = () => {
    useEffect(() => {
        pushGTMEventOnce(GA_DEDUP_KEYS.VIEW_EXPIRED_PAGE, GA_EVENT_CONFIGS.SAVE_CONTINUE_EXPIRED_PAGE_VIEWED);
    }, []);

    return (
        <>
            <title>Uncompleted Application Expired | AAA Life</title>
            <ApplicationContainer data-testid="uncompleted-application-expired-page">
                <UncompletedApplicationExpiredCard />
            </ApplicationContainer>
        </>
    );
};

export { UncompletedApplicationExpiredPage };
export default UncompletedApplicationExpiredPage;
